module.exports = {
	"dk": {
		"sport": "sport",
		"nyheder": "news",
		"premium": "premium",
		"podcasts": "podcasts",
		"blog": "blogs",
		"fodbold": "football",
		"handbold": "handball",
		"motorsport": [
			"motorsports",
			"speedway"
		],
		"nfl": "am-football",
		"kampsport": [
			"mixed-martial-arts",
			"fighting",
			"boxing"
		],
		"tennis": "tennis",
		"ishockey": "ice-hockey",
		"golf": "golf",
		"cykling": "cycling",
		"badminton": "badminton",
		"atletik": "athletics",
		"formula-2": "dakar-rally",
		"formula-3": "moto-3",
		"imsa": "british-superbike",
		"e-sport": "e-sport",
		"tokyo-2021": "rio-2016",
		"andre": {
			"not": [
				{
					"sports": "football"
				},
				{
					"sports": "handball"
				},
				{
					"sports": "motorsports"
				},
				{
					"sports": "speedway"
				},
				{
					"sports": "am-football"
				},
				{
					"sports": "fighting"
				},
				{
					"sports": "mixed-martial-arts"
				},
				{
					"sports": "boxing"
				},
				{
					"sports": "tennis"
				},
				{
					"sports": "ice-hockey"
				},
				{
					"sports": "golf"
				},
				{
					"sports": "cycling"
				},
				{
					"sports": "badminton"
				},
				{
					"sports": "athletics"
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/routeParamMappings.json
// module id = 414
// module chunks = 6